import type { BoxAction } from './states';

export const ROLES = ['worker', 'lead', 'office', 'admin'] as const;
export type Role = (typeof ROLES)[number];

export type Permission =
  | 'view'
  | 'scan'
  | 'override'
  | 'write_off'
  | 'found'
  | 'ship_partial'
  | 'close_transfer_missing'
  | 'resolve_discrepancy'
  | 'orders'
  | 'labels'
  | 'import'
  | 'export'
  | 'settings';

const LEAD_EXTRAS: Permission[] = ['override', 'write_off', 'found', 'ship_partial', 'close_transfer_missing', 'resolve_discrepancy'];

const GRANTS: Record<Role, ReadonlySet<Permission>> = {
  worker: new Set<Permission>(['view', 'scan']),
  lead: new Set<Permission>(['view', 'scan', ...LEAD_EXTRAS]),
  office: new Set<Permission>(['view', 'orders', 'labels', 'import', 'export']),
  admin: new Set<Permission>(['view', 'scan', ...LEAD_EXTRAS, 'orders', 'labels', 'import', 'export', 'settings']),
};

export function can(role: Role, permission: Permission): boolean {
  return GRANTS[role].has(permission);
}

export const ACTION_PERMISSION: Record<BoxAction, Permission> = {
  receive: 'scan',
  pick_order: 'scan',
  pick_transfer: 'scan',
  unpick: 'scan',
  ship: 'scan',
  send: 'scan',
  receive_transfer: 'scan',
  write_off: 'write_off',
  found: 'found',
  void: 'labels',
};
